<template>
    <nav class="nav-list">
        <div v-for="(item, index) in navigation" :key="`${item.Type}-${index}`">
            <a
                v-if="item.PageUrl"
                :href="item.PageUrl"
                class="nav-list__item"
                :class="{ 'is-active': desktopNavStore.getNavigationType === item.Type }">
                {{ item.Type }}
            </a>

            <button
                v-else
                type="button"
                class="nav-list__item"
                :class="{ 'is-active': desktopNavStore.getNavigationType === item.Type }"
                @click="desktopNavStore.setNavigationType(item.Type)">
                {{ item.Type }}
            </button>
        </div>
    </nav>
</template>

<script setup lang="ts">
import { INavigation } from '../../../interfaces/Navigation';
import { useDesktopNavStore } from '../store/desktop-nav.store';

defineProps<{
    navigation: INavigation[];
}>();

const desktopNavStore = useDesktopNavStore();
</script>
